export default "__VITE_ASSET__08f657d7__"